import { useEffect, useRef, useState } from "react";

import ThumbImg from "../../assets/images/conversations/blank.png";
// 005.webp
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: gf-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .gf-page {
    background: #1A1A1A;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .gf-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .gf-hero { padding-top: 60px; padding-bottom: 60px; }
  .gf-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .gf-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .gf-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gf-hero__title.gf-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .gf-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .gf-hero__social.gf-visible { opacity: 1; transform: translateY(0); }
  .gf-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .gf-hero__social a:hover { opacity: 0.85; }
  .gf-hero__social a.fb { background: #3B5998; }
  .gf-hero__social a.li { background: #0077B5; }
  .gf-hero__social a.tw { background: #1DA1F2; }
  .gf-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .gf-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .gf-hero__spotify.gf-visible { opacity: 1; transform: translateY(0); }
  .gf-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .gf-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .gf-hero__right.gf-visible { opacity: 1; transform: translateY(0); }

  .gf-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .gf-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .gf-yt-thumb:hover img { opacity: 0.85; }
  .gf-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .gf-yt-thumb__play img { width: 40px; height: 44px; }
  .gf-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .gf-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .gf-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gf-body.gf-visible { opacity: 1; transform: translateY(0); }
  .gf-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .gf-body__para:last-child { margin-bottom: 0; }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .gf-inner { padding-left: 32px; padding-right: 32px; }
    .gf-hero { padding-top: 32px; padding-bottom: 48px; }
    .gf-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .gf-hero__title { font-size: 24px; }
    .gf-hero__left { gap: 16px; }
    .gf-hero__social { gap: 10px; }
    .gf-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .gf-body__para { font-size: 14px; margin-bottom: 12px; }
    .gf-body { padding-bottom: 48px; }
    .gf-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .gf-inner { padding-left: 16px; padding-right: 16px; }
    .gf-hero { padding-top: 51px; padding-bottom: 30px; }
    .gf-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .gf-hero__left { gap: 30px; }
    .gf-hero__title { font-size: 30px; }
    .gf-hero__social { gap: 11px; }
    .gf-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .gf-body__para { font-size: 16px; margin-bottom: 10px; }
    .gf-body { padding-bottom: 30px; }
    .gf-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("gf-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP05_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="gf-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 05 Gigafactories Fireside"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="gf-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 05 Gigafactories Fireside thumbnail" />
      <div className="gf-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="gf-hero">
      <div className="gf-inner">
        <div className="gf-hero__grid">
          <div className="gf-hero__left">
            <div ref={titleRef} className="gf-hero__title">
              EP 05 | Fireside Chat With Industry Leaders On What Will Happen When The Gigafactories Arrive In India
            </div>
            <div ref={socialRef} className="gf-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="gf-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4pvZmXQajWsGhjqjXYhB2g?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 05 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="gf-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="gf-body">
      <div className="gf-inner">
        <p className="gf-body__para">
          Today's episode features four experienced thought leaders from the E Mobility sector in India discussing what the industry will likely experience once the first lithium-ion Gigafactories arrive in the country: Mahesh Godi, CEO Gudi Energy, Vikram HANDA, MD Epsilon Carbon Pvt Ltd, Stefan LOUIS, CEO Nexcharge (the ExidE/ Leclanché JV), and Dr. LN Satapathy, Additional General Manager, BHEL.
        </p>
        <p className="gf-body__para">
          In this fireside chat, we discuss Niti Aayog's initiatives to facilitate investment establishing over 50 GWH of manufacturing capacity in India in the next few years, covering in detail what will happen to battery prices, the geopolitical challenges of importing the raw materials in such large quantities when China dominates the value chain to its advantage, as well as their forecasts for when such a major uplift in capacity will happen in India. Tune in to hear perspectives from different parts of the lithium value chain.
        </p>
      </div>
    </section>
  );
}

export default function Ep05GigafactoriesFireside() {
  return (
    <>
      <style>{CSS}</style>
      <div className="gf-page">
        <HeroSection />
        <BodySection />
      </div>
    </>
  );
}